import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { OrganisationApiClient } from 'src/app/services/organisation.apiclient';
import { OrganisationSettingsApiClient } from 'src/app/services/organisation-settings.apiclient';

@Component({
    selector: 'authorized-page',
    templateUrl: './authorized.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AuthorizedPage implements OnInit {

  constructor(private authenticationService: AuthenticationService, private organisationApiClient: OrganisationApiClient, private organisationSettingsApiClient: OrganisationSettingsApiClient) { }
  private y: any;

  ngOnInit() {
    this.authenticationService.authorizeCallback();
    this.authenticationService.currentUser.subscribe((userData) => {
      if (userData != undefined && userData.organisationGuid != undefined) {
        this.organisationSettingsApiClient.getOrganisationSettings(userData.organisationGuid);
        this.organisationApiClient.getOrganisationPlugins(userData.organisationGuid);
      }
    });
  }
}
